<template>
    <div id="admin-blog-posts">
        <div v-for="blog in sortBlogs(blogs)" :key="blog.id" class="admin-blog-post-row">
            <div class="admin-blog-post-img">
                <img :src="blog.image | optimizeBlog" class="blog-img-preview" alt="">
            </div>
            <div class="admin-blog-post-col">
                <div class="row-header">Title</div>
                <div class="admin-blog-post-title">
                    {{ blog.title }}
                </div>
            </div>
            <div class="admin-blog-post-col">
                <div class="row-header">Date Created</div>
                <div class="admin-blog-post-datecreated">
                    {{ displayDate(blog.datecreated) }}
                </div>
            </div>
            <div class="admin-blog-post-col">
                <div class="row-header">Publish Date</div>
                <div class="admin-blog-post-datepublished">
                    {{ displayDate(blog.datepublished) }}
                </div>
            </div>
            <div class="admin-blog-post-col">
                <div class="row-header">Status</div>
                <div class="admin-blog-post-visibility">
                    {{ displayVisibility(blog.visibility) }}
                </div>
            </div>
            <div class="admin-blog-post-button" v-on:click="$emit('viewBlog', 'ViewBlogPost', blog)">
                View
            </div>
            <div class="admin-blog-post-button" v-on:click="$emit('viewBlog', 'EditBlogPost', blog)">
                Edit
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
    computed: {
        ...mapState(['blogs'])
    },
    methods: {
        displayVisibility: function(vis) {
            if (vis == 0) {
                return "Hidden"
            } else if (vis == 1) {
                return "Published"
            } else if (vis == 2) {
                return "Publish Scheduled"
            }
        },
        displayDate: function(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY -  HH:mm')
        },
        sortBlogs(blogs) {
            var copyBlogs = blogs.slice()
            copyBlogs.sort(function(a,b){return Date.parse(b.datepublished) - Date.parse(a.datepublished)})
            return copyBlogs
        }
    },
    filters: {
        optimizeBlog: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_1050/')
            return newUrl
        }
    }
}
</script>

<style>
.admin-blog-post-row {
    display: flex;
    justify-content: space-between;
    height:100px;
    width:90%;
    padding:5px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: white;

}
.admin-blog-post-img {
    height:100px;
    width: 100px;
    overflow: hidden;
}
.admin-blog-post-col {
    flex-basis: 20%;
}
.blog-img-preview {
    max-height:100px;
    width:auto;
    margin: 0 auto;
}
.admin-blog-post-title {
    font-size: 26px;
    max-height: 40px;
    overflow: hidden;
}
.admin-blog-post-datecreated {
    font-size: 26px;
}
.admin-blog-post-datepublished {
    font-size: 26px;
}
.admin-blog-post-visibility {
    font-size: 26px;
}
.admin-blog-post-button {
    margin-top: 25px;
    height: 50px;
    width: 100px;
    background-color: rgb(69, 144, 194);
    line-height: 50px;
    color: white;
    border-radius: 5px;
    margin-right: 5px;
    cursor: pointer;
}
.row-header {
    line-height: 30px;
    opacity: 0.5;
}
</style>